require('./LabelWithEllipses.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

class LabelWithEllipses extends React.Component {
    constructor(props) {
        super(props);
        this.titleText = React.createRef();
        this.state = {
            showOriginal: false,
            shouldHaveElipses: false,
        };
    }

    componentDidMount() {
        const titleTempElement = this.titleText.current;
        if (!this.state.showOriginal) {
            this.setLocalVariables(
                titleTempElement.scrollWidth >= titleTempElement.clientWidth,
            );
        }
    }

    setLocalVariables(shouldHaveElipses) {
        this.setState({
            shouldHaveElipses,
            showOriginal: true,
        });
    }

    render() {
        const {
            extraClasses,
            text,
            tooltipOffset,
            tooltipPlacement,
            tooltipModifier,
        } = this.props;
        const { showOriginal, shouldHaveElipses } = this.state;
        const hiddenTextClasses = classNames('label-with-ellipses', {
            [extraClasses]: !!extraClasses,
        });

        let label;
        if (showOriginal) {
            if (shouldHaveElipses) {
                const titleElement = (
                    <span className="label-with-ellipses__has-ellipses">
                        {text}
                    </span>
                );

                label = (
                    <OKTooltip
                        content={text}
                        offset={tooltipOffset}
                        placement={tooltipPlacement}
                        modifier={tooltipModifier}
                        target={titleElement}
                    />
                );
            } else {
                label = text;
            }
        } else {
            label = (
                <p ref={this.titleText} className={hiddenTextClasses}>
                    {text}
                </p>
            );
        }

        return label;
    }
}

LabelWithEllipses.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    extraClasses: PropTypes.string.isRequired, //class must have required font styles and width
    tooltipOffset: PropTypes.PropTypes.array,
    tooltipPlacement: PropTypes.string,
    tooltipModifier: PropTypes.string,
};
LabelWithEllipses.defaultProps = {
    text: '',
    tooltipOffset: [0, 0],
    tooltipPlacement: 'bottom',
    tooltipModifier: 'dark-bg',
};

module.exports = LabelWithEllipses;
